const breakpoints = {
  small: 640,
  medium: 768, //ipad portrait
  large: 1023, //ipad landscape
  xlarge: 1244, //1280px screen resolution minus scrollbars
  xxlarge: 1410, // 1440px screen resolution minus scrollbars
};

const Theme = {
  colours: {
    primary: '#D6C9BF',
    primaryDark: '#C6B5A9',
    black: '#565656',
    complete: '#06d6a0',
    info: '#db00ff',
    blue: '#1859ff',
  },
  status: {
    UNTOUCHED: '#FFDC81',
    DRAFT: '#FFDC81',
    MODIFIED: '#FFDC81',
    REVIEW: '#C9D6E8',
    PENDING: '#F9AC88',
    MERGED: '#06d6a0',
    VALIDATED: '#06d6a0',
    APPROVED: '#06d6a0',
    REJECTED: '#ff0054',
    TODO: '#D6C9BF',
    ARCHIVED: '#D6C9BF',
  },
  greys: {
    GREY0: '#f4f4f4',
    GREY1: '#dddddd',
    GREY2: '#c5c5c5',
    GREY3: '#989898',
    GREY4: '#6f6f6f',
    GREY5: '#474747',
    GREY6: '#222222',
  },
  font: "'Poppins', sans-serif",
  breakpoints,
  mediaQueries: {
    desktop: `@media screen and (min-width: ${breakpoints.large}px)`,
    xlarge: `@media screen and (min-width: ${breakpoints.xlarge}px)`,
  },
  layers: {
    header: 10,
  },
};

export default Theme;
